import { DialogRef } from '@angular/cdk/dialog';
import { NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserActions } from '@core/data-access/actions/user.actions';
import { UserAnnouncement } from '@core/utils/models/user.model';
import { Store } from '@ngrx/store';

@Component({
  selector: 'lf-announcement-dialog',
  imports: [MatDialogModule, MatButtonModule, NgOptimizedImage],
  templateUrl: './announcement-dialog.component.html',
  styleUrl: './announcement-dialog.component.css',
})
export class AnnouncementDialogComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly dialogRef = inject(DialogRef);
  private readonly router = inject(Router);

  public readonly data = inject<UserAnnouncement>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.store.dispatch(UserActions.markAnnouncementAsSeen({ announcementId: this.data.announcement_id }));
  }

  subscribe(): void {
    this.closeDialog();
    this.router.navigate(['/payment']);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
